import styled from 'styled-components';
import Map from './Map';
import { getLocations } from './util';

export default function LocationList(props) {
  let { data, filter, setFilter, setLocation } = props;
  return (
    <Wrap>
      <div className="photos">
        <div>
          {getLocations(filter, data).map((l) => (
            <Location
              key={l.totem_id}
              onClick={() => props.setLocation(l)}
              name={l.name}
              city={l.city_name}
              image={l.images[0]?.main}
            />
          ))}
        </div>
      </div>
      <div id="map" className="map">
        <Map data={data} filter={filter} setFilter={setFilter} setLocation={setLocation} />
      </div>
    </Wrap>
  );
}

let Wrap = styled.div`
  .photos > div {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    align-content: flex-start;
    background: white;
    padding-top: 20px;
    padding-bottom: 60px;
  }

  @media (min-width: 1001px) {
    display: flex;
    flex: 1;
    align-items: stretch;

    .photos {
      display: flex;
      flex: 1;
      flex-direction: column;
    }

    .photos > div {
      flex: 1 1 auto;
      height: 0px;
      overflow-y: auto;
    }

    .map {
      flex: 1;
    }

    .mapbox-map {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 1000px) {
    .mapbox-map {
      display: none;
    }
  }
`;

function Location(props) {
  let { name, city, image, onClick } = props;
  return (
    <LocationWrap onClick={onClick}>
      <div className="img-wrap">
        <img loading="lazy" src={image} alt="" />
      </div>
      <div className="city">{ city }</div>
      <div className="name">{name}</div>
    </LocationWrap>
  );
}

let LocationWrap = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  padding: 10px 20px;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;
    top: 0;
    left: 0;
    transition: transform 0.4s ease-in-out;
  }

  &:hover img {
    transform: scale(1.1);
  }

  &:hover {
    color: #0cd459;
  }

  .img-wrap {
    width: 100%;
    padding-top: 56.25%; /* 16 : 9 */
    position: relative;
    overflow: hidden;
    margin-bottom: 10px;
  }

  .name {
    margin-top: 5px;
    font-size: 18px;
  }

  .city {
    text-transform: uppercase;
    font-weight: bold;
    font-size: 11px;
    letter-spacing: 1.1px;
    color: #707070;
  }

  @media (min-width: 500px) {
    width: 50%;
    padding: 12px;
  }

  @media (min-width: 1001px) {
    width: calc(50% - 30px);
    padding: 10px;

    &:nth-child(odd) {
      margin: 0 10px 0 20px;
    }

    &:nth-child(even) {
      margin: 0 20px 0 10px;
    }
  }
`;
